import { useQuery } from "@apollo/client/react";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import type { ValidationResultResponse } from "../../../models/InvoiceModels";

export const useInvoiceLatestValidationResult = (
  clientIdentifier: string,
  invoiceId: string,
) => {
  const { data, error, loading, refetch } = useQuery<{
    invoice: ValidationResultResponse;
  }>(GET_INVOICE_LATEST_VALIDATION_RESULT, {
    variables: {
      clientIdentifier: clientIdentifier,
      invoiceId: invoiceId,
    },
    errorPolicy: "all",
  });
  return { invoice: data?.invoice, error, loading, refetch };
};
